export default __webpack_public_path__ + "static/gla_thumb-70a76d062aa951a4abf79f5b1b77c89b.png";